const diagonQuizQuestions = [
  {
    question: "How many Sickles are in a Galleon?",
    answers: [
      { answer: "17 Sickles", isCorrect: true },
      { answer: "22 Sickles", isCorrect: false },
      { answer: "15 Sickles", isCorrect: false },
      { answer: "12 Sickles", isCorrect: false }
    ]
  },
  {
    question: "Which one of these is the name of the Ice Cream Parlour in Diagon Alley?",
    answers: [
      { answer: "Flourish and Blotts", isCorrect: false },
      { answer: "The Leaky Cauldron", isCorrect: false },
      { answer: "Florean Fortescue's", isCorrect: true },
      { answer: "Magical Menagerie", isCorrect: false }
    ]
  },
  {
    question: "Can you trade Muggle money for Wizard money at Gringotts?",
    answers: [
      { answer: "No way! They don't accept Muggle money.", isCorrect: false },
      { answer: "Of course you can!", isCorrect: true },
    ]
  },
  {
    question: "Where is Diagon Alley Located?",
    answers: [
      { answer: "No one really knows", isCorrect: false },
      { answer: "Behind the Leaky Cauldron", isCorrect: true },
      { answer: "The location often changes", isCorrect: false },
      { answer: "Inside Knockturn Alley", isCorrect: false }
    ]
  },
  {
    question: "What did Fred and George name their joke shop?",
    answers: [
      { answer: "Weasleys Palace of Jokes", isCorrect: false },
      { answer: "Gambol and Japes Wizarding Joke Shope", isCorrect: false },
      { answer: "Fred and Georges' Joke Shop", isCorrect: false },
      { answer: "Weasleys' Wizard Wheezes", isCorrect: true }
    ]
  },

]

export default diagonQuizQuestions
